module.exports = __webpack_public_path__ + "static/me-1022b06fa63e407fe6d5779dae1bb95e.png";